// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Container-__Container-module___container","classroom":"src-components-Container-__Container-module___classroom","student":"src-components-Container-__Container-module___student","photos":"src-components-Container-__Container-module___photos","photosInnerContainer":"src-components-Container-__Container-module___photosInnerContainer","loader":"src-components-Container-__Container-module___loader"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Container/Container.module.css
// module id = 77
// module chunks = 0